import { render, staticRenderFns } from "./JournalSearch.vue?vue&type=template&id=469ceae8&scoped=true&"
import script from "./JournalSearch.vue?vue&type=script&lang=js&"
export * from "./JournalSearch.vue?vue&type=script&lang=js&"
import style0 from "./JournalSearch.vue?vue&type=style&index=0&id=469ceae8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469ceae8",
  null
  
)

export default component.exports